<h1 mat-dialog-title>Cart reset</h1>

<div mat-dialog-actions>
    <button mat-button mat-raised-button color="primary" class="mb-3" cdkFocusInitial (click)="resetCart()">Confirm</button>
</div>
